import {branch, compose, renderNothing} from "recompose";
import _ from "lodash";
import {useMemo, useState} from "react";
import useAsyncWithCache from "../../../../modules/asyncCache/useAsyncWithCache";
import {bindQueryParam} from "../../functions/routerHelper";
import {getResponseItems} from "../../../Shared";
import {feedback_getFeedbackCategories_Api} from "../../../../apis";


export const FeedbackCategoryAsyncWrapper = compose(
  branch(({systemAdmin}) => !!systemAdmin, renderNothing)
)(({children}) => {
  const [values, setValues] = useState()

  const apiInfo = feedback_getFeedbackCategories_Api

  const cacheId = useMemo(
    () =>
      [apiInfo?.path, JSON.stringify(values)].join(
        '/'
      ),
    [values]
  )

  const {response, isLoading} = useAsyncWithCache({
    values,
    cacheId,
    apiInfo,
    query: bindQueryParam({}),
  })

  return _.isFunction(children)
    ? children({
      isLoading,
      items: getResponseItems(response),
      onSearch: (keyword) => {
        setValues({
          keyword,
        })
      },
    })
    : children
})